(function($) {

    'use strict';
    
    var angleRatio = 0.25;

	var init = function() {
        $(window).resize(function(){

            clipAngle('.clipAngle');
            
            if($(window).outerWidth() >= 767){
                clipAngle('.clipAngleLaptop');
            }else{
                cleanClipAngle('.clipAngleLaptop');
            }


        }).resize();

    };  
    
    var cleanClipAngle = function($selector){

        $($selector).each(function(){

            $(this).css('width', '');
            $(this).css('clip-path', '');

        })

    }
    
    var clipAngle = function($selector){

        $($selector).each(function(){

            $(this).css('width', '');

            var itemHeight = $(this).outerHeight();
            if($(this).hasClass('defineWidth')){
                var itemwidth = Math.ceil(itemHeight*angleRatio);
                $(this).width(itemwidth);
            }else if($(this).hasClass('addWidth')){
                var itemwidth = $(this).width() + Math.ceil(itemHeight*angleRatio);
				$(this).width(itemwidth);
			}else if($(this).hasClass('defineWidthSpecial')){
                var itemwidth = $(this).width() + Math.ceil(itemHeight*angleRatio) + 2;
                $(this).width(itemwidth);
            }else{
                var itemwidth = $(this).outerWidth();
            }
            
            if($(this).hasClass('clipBoth')){

                $(this).css('clip-path', 'polygon(' + Math.ceil(itemHeight*angleRatio) + 'px 0, 100% 0, ' + (itemwidth - Math.ceil(itemHeight*angleRatio)) + 'px 100%, 0 100%)');

            }else if($(this).hasClass('clipLeft')){

                $(this).css('clip-path', 'polygon(' + Math.ceil(itemHeight*angleRatio) + 'px 0, 100% 0, 100% 100%, 0 100%)');

            }else if($(this).hasClass('clipBothRight')){

                $(this).css('clip-path', 'polygon(0 0, ' + (itemwidth - Math.ceil(itemHeight*angleRatio)) + 'px 0, 100% 100%, ' + Math.ceil(itemHeight*angleRatio) + 'px 100%)');

            }else{

                $(this).css('clip-path', 'polygon(0 0, 100% 0, ' + (itemwidth - Math.ceil(itemHeight*angleRatio)) + 'px 100%, 0 100%)');

            }

        })
        
    }

	$(document).ready(function() {
		init(); 
	});

})(jQuery);